import axios from "axios";
import { API_URL } from "../utils/constant";
import {
  GET_FOREST_LIST,
  CUSTOMERS_FETCHED,
  CUSTOMER_CREATED,
  CREATING_CUSTOMER,
  UPDATING_CUSTOMER,
  CUSTOMER_UPDATED,
  DELETING_CUSTOMER,
  CUSTOMER_DELETED,
  FETCHING_CUSTOMERS,
  FETCHING_THREAT_ANALYIST,
  CREATING_VENDOR,
  VENDORS_FETCHED,
  VENDOR_CREATED,
  FETCHING_VENDORS,
  GETING_DATA_BY_LOCALSTORAGE,
  USER_LOGGED_IN,
  GET_TRIAL_REQUEST,
  GET_FOREST_VIEW,
  FOREST_GRAPH_ATTACKSURFACE,
  FOREST_GRAPH_DATAEXPOSURE,
  FOREST_GRAPH_BRANDSECURITY,
  FOREST_GRAPH_DASHBOARD,
  FOREST_VENDOR_COUNT,
  FOREST_AVG_SCORE,
  FOREST_RATING_LIST,
  FOREST_LOWEST_LIST,
  FETCHING_CUSTOMERS_ID,
  COMPANY_LIST,
  SUBDOMAIN_SUGGEST,
  RISK_SEARCH_LIST,
  FETCHING_TAKEDOWN,
  GET_SCAN_SCHEDULE,
  CUSTOMERS_FETCHED_TOTAL,
  CUSTOMER_DOMAINS_FETCHED
} from "./index";
import { toastr } from "react-redux-toastr";


export const fetchCustomers = (props) => (dispatch) => {

  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FETCHING_CUSTOMERS,
    payload: null,
  });
  axios
    .get(`${API_URL}/customer`, {})
    .then((response) => {
      dispatch({
        type: CUSTOMERS_FETCHED,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: CUSTOMERS_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};


export const createCustomer = (props, auth, dispatch) => {
  return new Promise((resolve, reject) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    dispatch({
      type: CREATING_CUSTOMER,
      payload: null,
    });
    axios
      .post(`${API_URL}/customer`, { ...props })
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
          dispatch({
            type: CUSTOMER_CREATED,
            payload: { error: true, userMessage: response.data.userMessage },
          });
          reject(response.data.userMessage);
        } else {
          toastr.success("Success", response.data.userMessage);
          dispatch({
            type: CUSTOMERS_FETCHED,
            payload: response.data,
          });
          if (auth?.organisationId?.clientType == 3) {
            dispatch({
              type: USER_LOGGED_IN,
              payload: response.data.user,
            });
          }
          resolve();
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        toastr.error("Error", message);
        // dispatch({
        //   type: CUSTOMER_CREATED,
        //   payload: { error: true, userMessage: message },
        // });
        reject(message); // Reject promise if error occurs
      });
  });
};

// export const createCustomer = (props, auth, dispatch) => {
//   // const cookie = new Cookies();
//   // const session = cookie.get("session");
//   const session = localStorage.getItem("session");
//   axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
//   dispatch({
//     type: CREATING_CUSTOMER,
//     payload: null,
//   });
//   axios
//     .post(`${API_URL}/customer`, { ...props })
//     .then((response) => {
//       // window.location.href = '/customers'
//       if (response.data.error)
//         toastr.error("Error", response.data.userMessage);
//       else
//         toastr.success("Success", response.data.userMessage);
//       dispatch({
//         type: CUSTOMERS_FETCHED,
//         payload: response.data,
//       });
//       if (auth?.organisationId?.clientType == 3) {
//         dispatch({
//           type: USER_LOGGED_IN,
//           payload: response.data.user,
//         });
//       }
//     })
//     // .catch((err) => {
//     //   var message = "Some server error has occurred.";
//     //   if (err.response) {
//     //     message = err.response.data.userMessage;
//     //   }
//     //   dispatch({
//     //     type: CUSTOMER_CREATED,
//     //     payload: { error: true, userMessage: message },
//     //   });
//     // });
// };

export const createVendor = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: CREATING_VENDOR,
    payload: null,
  });
  axios
    .post(`${API_URL}/vendor`, { ...props })
    .then((response) => {
      // window.location.href = '/customers'
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        toastr.success("Success", response.data.userMessage);
      dispatch({
        type: VENDORS_FETCHED,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      dispatch({
        type: VENDOR_CREATED,
        payload: { error: true, userMessage: message },
      });
    });
};

export const updateScan = (props, dispatch, status) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios
    .put(`${API_URL}/organisations/${props}/active-vulnerabilities/scan/${status}`)
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        fetchCustomersNew(dispatch)
      toastr.success("Success", response.data.userMessage);
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
    });
};

export const updateVendor = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  // dispatch({
  //   type: VENDORS_FETCHED,
  //   payload: null,
  // });
  axios
    .put(`${API_URL}/vendor`, { ...props, customerId: props.orgId })
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        toastr.success("Success", response.data.userMessage);
      dispatch({
        type: VENDORS_FETCHED,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: VENDORS_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};

export const customerApproveToggle = (props) => (dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios
    .put(`${API_URL}/customer`, { ...props })
    .then((response) => {
      dispatch({
        type: CUSTOMERS_FETCHED,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: CUSTOMERS_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};


export const fetchCustomersById = (customerId, dispatch) => {
  return new Promise((resolve, reject) => {
    const session = localStorage.getItem('session');
    axios.defaults.headers.common['Authorization'] = `Bearer ${session}`;
    dispatch({
      type: FETCHING_CUSTOMERS_ID,
      payload: null,
    });
    axios
      .get(`${API_URL}/customer/${customerId}`)
      .then((response) => {
        dispatch({
          type: FETCHING_CUSTOMERS_ID,
          payload: response.data,
        });
        resolve(response.data?.data[0] || []);
      })
      .catch((err) => {
        let message = 'Some server error has occurred.';
        if (err.response && err.response.data && err.response.data.userMessage) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: FETCHING_CUSTOMERS_ID,
          payload: { error: true, userMessage: message },
        });
        reject(err);
      });
  });
};


// export const fetchCustomersById = (props,dispatch) => {
//   const session = localStorage.getItem("session");
//   axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

//   dispatch({
//     type: FETCHING_CUSTOMERS_ID,
//     payload: null,
//   });

//   axios
//     .get(`${API_URL}/customer/${props}`, {})
//     .then((response) => {
//       dispatch({
//         type: FETCHING_CUSTOMERS_ID,
//         payload: response.data,
//       });
//     })
//     .catch((err) => {
//       var message = "Some server error has occurred.";
//       if (err.response) {
//         message = err.response.data.userMessage;
//       }

//       dispatch({
//         type: FETCHING_CUSTOMERS_ID,
//         payload: { error: true, userMessage: message },
//       });
//     });
// };

export const deleteCustomer = (props) => (dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: DELETING_CUSTOMER,
    payload: null,
  });
  axios
    .delete(`${API_URL}/customer/${props}`, {})
    .then((response) => {
      dispatch({
        type: CUSTOMER_DELETED,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: CUSTOMER_DELETED,
        payload: { error: true, userMessage: message },
      });
    });
};

export const updateCustomer = (props, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: UPDATING_CUSTOMER,
    payload: null,
  });
  return axios
    .put(`${API_URL}/customer`, { ...props, customerId: props.orgId })
    .then((response) => {
      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
        dispatch({
          type: CUSTOMER_UPDATED,
          payload: { error: true, userMessage: response.data.userMessage },
        });
        return Promise.reject(response.data.userMessage);
      } else {
        toastr.success("Success", response.data.userMessage);
        dispatch({
          type: CUSTOMERS_FETCHED,
          payload: response.data,
        });
        return Promise.resolve();
      }
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
        toastr.error("Error", message);
      }
      dispatch({
        type: CUSTOMER_UPDATED,
        payload: { error: true, userMessage: message },
      });
      return Promise.reject(message);
    });
};
// export const updateCustomer = (props, dispatch) => {
//   // const cookie = new Cookies();
//   // const session = cookie.get("session");
//   const session = localStorage.getItem("session");
//   axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
//   dispatch({
//     type: UPDATING_CUSTOMER,
//     payload: null,
//   });
//   axios
//     .put(`${API_URL}/customer`, { ...props, customerId: props.orgId })
//     .then((response) => {
//       if (response.data.error)
//         toastr.error("Error", response.data.userMessage);
//       else
//         toastr.success("Success", response.data.userMessage);
//       dispatch({
//         type: CUSTOMERS_FETCHED,
//         payload: response.data,
//       });
//     })
//     .catch((err) => {
//       var message = "Some server error has occurred.";
//       if (err.response) {
//         message = err.response.data.userMessage;
//       }

//       dispatch({
//         type: CUSTOMER_UPDATED,
//         payload: { error: true, userMessage: message },
//       });
//     });
// };

export const refreshCustomer = (props) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  // dispatch({
  //   type: CREATING_CUSTOMER,
  //   payload: null,
  // });
  axios
    .post(`${API_URL}/customer/refresh/${props}`)
    .then((response) => {
      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        toastr.success("Success", response.data.userMessage);
      }
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      // dispatch({
      //   type: CUSTOMER_CREATED,
      //   payload: { error: true, userMessage: message },
      // });
    });

}

export const fetchThreatAnalyst = (dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FETCHING_THREAT_ANALYIST,
    payload: null,
  });
  axios
    .get(`${API_URL}/threatAnalyist`, {})
    .then((response) => {
      dispatch({
        type: FETCHING_THREAT_ANALYIST,
        payload: response.data.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FETCHING_THREAT_ANALYIST,
        payload: { error: true, userMessage: message },
      });
    });
}

export const fetchCustomersNew = (dispatch, page = 1, limit = 10, searchBy = "", clientSearch = "all") => {

  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FETCHING_CUSTOMERS,
    payload: null,
  });
  const encodedSearch = encodeURIComponent(searchBy || "");
  const filterQuery = clientSearch === "forestView"
    ? "orgType=forestView"
    : `client=${encodeURIComponent(clientSearch)}`;

  axios
    .get(`${API_URL}/customer?page=${page}&limit=${limit}&name=1&searchBy=${encodedSearch}&${filterQuery}`, {})
    .then((response) => {
      // const data = response?.data?.data?.filter((data) => data.clientType != 3)
      const data = response?.data?.data?.map((res) => ({
        ...res,
        currentRating: res?.rating?.filter((row) => row?.scanCounter == res?.scanCounter)?.pop(),
      }));
      let data_ = {
        data
      }
      dispatch({
        type: CUSTOMERS_FETCHED,
        payload: data_,
      });
       dispatch({
        type: CUSTOMERS_FETCHED_TOTAL,
        payload: response?.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: CUSTOMERS_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};

export const fetchVendors = (dispatch) => {

  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FETCHING_VENDORS,
    payload: null,
  });
  axios
    .get(`${API_URL}/vendor`, {})
    .then((response) => {
      dispatch({
        type: VENDORS_FETCHED,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: VENDORS_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};

export const deleteCustomerNew = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios
    .delete(`${API_URL}/customer/${props}`, {})
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        toastr.success("Success", response.data.userMessage);
      // dispatch({
      //   type: CUSTOMERS_FETCHED,
      //   payload: response.data,
      // });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: CUSTOMERS_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};

export const updateScanCounter = (props, dispatch) => {

  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  
  axios
    .put(`${API_URL}/updatedScanCounter/${props.scanCounter}/${props.orgId}`)
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        toastr.success("Success", response.data.userMessage);
      localStorage.setItem("org", JSON.stringify(response.data.data));
      dispatch({
        type: GETING_DATA_BY_LOCALSTORAGE,
        localClient: response.data.data,
      });
      window.location.reload();

    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: VENDORS_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};

export const logout = () => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("refreshToken");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  // dispatch({
  //   type: VENDORS_FETCHED,
  //   payload: null,
  // });
  axios
    .delete(`${API_URL}/logout?param=logout`)
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else {
        window.location.replace("/login");
        toastr.success("Success", response.data.userMessage);
        localStorage.clear();
      }
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
    });
};


export const getTrialRequest = (dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FETCHING_VENDORS,
    payload: null,
  });
  axios
    .get(`${API_URL}/trialRequest`, {})
    .then((response) => {
      dispatch({
        type: GET_TRIAL_REQUEST,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: GET_TRIAL_REQUEST,
        payload: { error: true, userMessage: message },
      });
    });
}

export const updateTrialRequest = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  // dispatch({
  //   type: VENDORS_FETCHED,
  //   payload: null,
  // });
  axios
    .post(`${API_URL}/trialRequest/approve/${props.id}?status=${props.status}`)
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else {
        toastr.success("Success", response.data.userMessage);
        dispatch({
          type: GET_TRIAL_REQUEST,
          payload: response.data,
        });
      }
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: VENDORS_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};

export const sendUserInvite = (props) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  axios
    .get(`${API_URL}/send-reminder/${props.email}`)
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        toastr.success("Success", response.data.userMessage);
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }


    });
}

export const createCustomerforestView = async (props, id, auth, dispatch) => {
  try {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    
    dispatch({
      type: GET_FOREST_VIEW,
      payload: null,
    });
    
    const response = await axios.post(`${API_URL}/organisations/${id}/fv-client/`, { ...props });
    
    if (response.data.error) {
      toastr.error("Error", response.data.userMessage);
    } else {
      toastr.success("Success", response.data.userMessage);
    }
    
    dispatch({
      type: GET_FOREST_VIEW,
      payload: response.data,
    });
    
    return response.data;
  } catch (err) {
    let message = "Some server error has occurred.";
    if (err.response) {
      message = err.response.data.userMessage;
    }
    
    dispatch({
      type: GET_FOREST_VIEW,
      payload: { error: true, userMessage: message },
    });
    
    throw err;
  }
};

export const uploadexcelforest = (props, id, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: GET_FOREST_VIEW,
    payload: null,
  });
  axios.post(`${API_URL}/organisation/${id}/fv-client/excel`, props)
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        toastr.success("Success", response.data.userMessage);
      dispatch({
        type: GET_FOREST_VIEW,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      dispatch({
        type: GET_FOREST_VIEW,
        payload: { error: true, userMessage: message },
      });
    });
};

export const fetchCustomersforestView = (orgId, dispatch, page, orgName, sortField, sortOrder, tags, criticality, limit = 10) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: GET_FOREST_VIEW,
    payload: null,
  });
  axios
    .get(`${API_URL}/organisations/${orgId}/fv-client/?page=${page}&limit=${limit}&orgName=${orgName}&sortField=${sortField}&sortOrder=${sortOrder}&tags=${tags}&criticality=${criticality}`)
    .then((response) => {
      dispatch({
        type: GET_FOREST_VIEW,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: GET_FOREST_VIEW,
        payload: { error: true, userMessage: message },
      });
    });
};

export const fetchCustomersforestViewSearch = (orgId, dispatch, tech, search) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: GET_FOREST_LIST,
    payload: null,
  });
  axios
    .get(`${API_URL}/forestView/organizations/${orgId}/search/${tech}/${search}`)
    .then((response) => {
      dispatch({
        type: GET_FOREST_LIST,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: GET_FOREST_LIST,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestGraphAttack = (orgId, dispatch) => {
  // Forest View
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FOREST_GRAPH_ATTACKSURFACE,
    payload: null,
  });
  axios
    .get(`${API_URL}/forestView/organizations/${orgId}/stats/attacksurface/graph`)
    .then((response) => {
      dispatch({
        type: FOREST_GRAPH_ATTACKSURFACE,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FOREST_GRAPH_ATTACKSURFACE,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestGraphDataexposure = (orgId, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FOREST_GRAPH_DATAEXPOSURE,
    payload: null,
  });
  axios
    .get(`${API_URL}/forestView/organizations/${orgId}/stats/dataexposure/graph`)
    .then((response) => {
      dispatch({
        type: FOREST_GRAPH_DATAEXPOSURE,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FOREST_GRAPH_DATAEXPOSURE,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestGraphBrandSecurity = (orgId, dispatch) => {
  // Forest View
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FOREST_GRAPH_BRANDSECURITY,
    payload: null,
  });
  axios
    .get(`${API_URL}/forestView/organizations/${orgId}/stats/brandsecurity/graph`)
    .then((response) => {
      dispatch({
        type: FOREST_GRAPH_BRANDSECURITY,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FOREST_GRAPH_BRANDSECURITY,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestGraphDashboard = (orgId, dispatch) => {
  // Forest View
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FOREST_GRAPH_DASHBOARD,
    payload: null,
  });
  axios
    .get(`${API_URL}/forest-view/organisations/${orgId}/avgscore-graph`)
    .then((response) => {
      dispatch({
        type: FOREST_GRAPH_DASHBOARD,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FOREST_GRAPH_DASHBOARD,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestVendorDashboard = (orgId, dispatch) => {
  // Forest View
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FOREST_VENDOR_COUNT,
    payload: null,
  });
  axios
    .get(`${API_URL}/forest-view/organisations/${orgId}/total-vendors`)
    .then((response) => {
      dispatch({
        type: FOREST_VENDOR_COUNT,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FOREST_VENDOR_COUNT,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestAvgScoreDashboard = (orgId, dispatch) => {
  // Forest View
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FOREST_AVG_SCORE,
    payload: null,
  });
  axios
    .get(`${API_URL}/forest-view/organisations/${orgId}/avgscore`)
    .then((response) => {
      dispatch({
        type: FOREST_AVG_SCORE,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FOREST_AVG_SCORE,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestRatingDecline = (orgId, dispatch, page) => {
  // Forest View
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FOREST_RATING_LIST,
    payload: null,
  });
  axios
    .get(`${API_URL}/forest-view/organisations/${orgId}/rating-decline?page=${page}`)
    .then((response) => {
      dispatch({
        type: FOREST_RATING_LIST,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FOREST_RATING_LIST,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestLowestRating = (orgId, dispatch, page) => {
  // Forest View
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: FOREST_LOWEST_LIST,
    payload: null,
  });
  axios
    .get(`${API_URL}/organisations/${orgId}/fv-client?sortField=totalImpact&sortOrder=asc&page=${page}`)
    .then((response) => {
      dispatch({
        type: FOREST_LOWEST_LIST,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: FOREST_LOWEST_LIST,
        payload: { error: true, userMessage: message },
      });
    });
};

export const deleteCustomerforest = (props, id, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios
    .delete(`${API_URL}/organisations/${props}/fv-client/${id}`, {})
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        toastr.success("Success", response.data.userMessage);
      dispatch({
        type: GET_FOREST_VIEW,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: GET_FOREST_VIEW,
        payload: { error: true, userMessage: message },
      });
    });
};

export const updateCustomerforest = (props, id, updateId, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios
    .put(`${API_URL}/organisations/${id}/fv-client/${updateId}`, { ...props })
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        toastr.success("Success", response.data.userMessage);
      dispatch({
        type: GET_FOREST_VIEW,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: GET_FOREST_VIEW,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestCompanyList = (orgId, module_name, dispatch, organisations) => {
  // Forest View
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: COMPANY_LIST,
    payload: null,
  });
  axios
    .get(`${API_URL}/forestView/organizations/${orgId}/stats/${module_name}/list/companies?organisations=${organisations == 'undefined' || organisations == undefined ? '' : organisations}`)
    .then((response) => {
      dispatch({
        type: COMPANY_LIST,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: COMPANY_LIST,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestSubdomainList = (dispatch) => {
  // Forest View
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: SUBDOMAIN_SUGGEST,
    payload: null,
  });
  axios
    .get(`${API_URL}/forest-view/suggest-submodules`)
    .then((response) => {
      dispatch({
        type: SUBDOMAIN_SUGGEST,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: SUBDOMAIN_SUGGEST,
        payload: { error: true, userMessage: message },
      });
    });
};

export const forestlistSearchRisk = (id, dispatch, orgName) => {
  // Forest View
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  dispatch({
    type: RISK_SEARCH_LIST,
    payload: null,
  });
  axios
    .get(`${API_URL}/organisations/${id}/fv-client?orgName=${orgName}`)
    .then((response) => {
      dispatch({
        type: RISK_SEARCH_LIST,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: RISK_SEARCH_LIST,
        payload: { error: true, userMessage: message },
      });
    });
};

export const fetchTakeDown = (dispatch, page = 1, limit = 10, search = '', status = 'all', moduleName = 'all') => {
  return new Promise((resolve, reject) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    dispatch({
      type: FETCHING_TAKEDOWN,
      payload: null,
    });
    
    // Build query parameters
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    
    if (search && search.trim()) {
      params.append('search', search.trim());
    }
    
    if (status && status !== 'all') {
      params.append('status', status);
    }
    
    if (moduleName && moduleName !== 'all') {
      params.append('moduleName', moduleName);
    }
    
    axios
      .get(`${API_URL}/ticket?${params.toString()}`, {})
      .then((response) => {
        dispatch({
          type: FETCHING_TAKEDOWN,
          payload: response.data,
        });
        resolve(response.data);
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCHING_TAKEDOWN,
          payload: { error: true, userMessage: message },
        });
        reject(err);
      });
  });
};

export const fetchTakeDownAction = (dispatch, id, data) => {
  return new Promise((resolve, reject) => {
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    
    axios
      .patch(`${API_URL}/ticket/${id}`, data)
      .then((response) => {
        if (response.data.error) {
          reject(new Error(response.data.userMessage));
        } else {
          resolve(response.data);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        reject(new Error(message));
      });
  });
};

// Start scan for Forest View client
export const startScan = (organisationId, fvClientId, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  axios
    .put(`${API_URL}/organisation/${organisationId}/fv-client/${fvClientId}/refresh`)
    .then((response) => {
      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        toastr.success("Success", response.data.userMessage);
        // Refresh the forest view list to show updated status
        fetchCustomersforestView(organisationId, dispatch, 1, "", "", "", "", "");
      }
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      toastr.error("Error", message);
    });
};

export const scheduleScan = (organisationId, data, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  axios
    .put(`${API_URL}/update-all-monitoring/${organisationId}`, data)
    .then((response) => {
      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        toastr.success("Success", response.data.userMessage);
        // Refresh the forest view list to show updated status
        fetchCustomersforestView(organisationId, dispatch, 1, "", "", "", "", "");
      }
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      toastr.error("Error", message);
    });
};

export const getScanSchedule = (organisationId, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  axios
    .get(`${API_URL}/organisations/${organisationId}/monitoring-settings`)
    .then((response) => {
      if (response.data.error) {
        // toastr.error("Error", response.data.userMessage);
      } else {
        // toastr.success("Success", response.data.userMessage);
        dispatch({
          type: GET_SCAN_SCHEDULE,
          payload: response.data,
        });
      }
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      toastr.error("Error", message);
    });
};

// MSSP Child Organizations Scan Configuration
export const fetchMSSPChildOrgsScanConfig = (msspOrgId, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  
  axios
    .get(`${API_URL}/mssp/${msspOrgId}/child-orgs/scan-configuration`)
    .then((response) => {
      if (response.data.error) {
        toastr.error("Error", response.data.userMessage);
      } else {
        // Store the scan configuration data in localStorage or state as needed
        localStorage.setItem("msspChildOrgsScanConfig", JSON.stringify(response.data.data));
      }
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      // console.error removed
      // Don't show error toast for this as it's not critical for login flow
    });
};

export const fetchCustomerDomains = (organisationId) => (dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  
  axios
    .get(`${API_URL}/customer/${organisationId}/domains`, {})
    .then((response) => {
      dispatch({
        type: CUSTOMER_DOMAINS_FETCHED,
        payload: response.data,
      });
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
      
      dispatch({
        type: CUSTOMER_DOMAINS_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};